export default __webpack_public_path__ + "static/avatar-tag-2-dont-dark-4cfd9d21fc0e240119dd5ea20d5e32ae.png";